// Public Broadcastify scanner feeds per WA county.
// Source: https://www.broadcastify.com/listen/stid/53 (Nov 2025 snapshot)
// To add/edit feeds: just push another object into the array — id is the
// Broadcastify feed ID from the URL `/listen/feed/{id}`. The MP3 stream
// works without auth from `https://broadcastify.cdnstream1.com/{id}` and
// the embed link uses `/listen/feed/{id}/web`.

export const SCANNER_FEEDS = {
  okanogan: [
    { id: 47023, name: "Okanogan County Public Safety", desc: "Sheriff · Fire · EMS · WSP" },
  ],
  chelan: [
    { id: 24557, name: "Chelan & Douglas Co. Sheriff, Fire, EMS", desc: "RiverCom dispatch · WSP" },
  ],
  douglas: [
    { id: 24557, name: "Chelan & Douglas Co. Sheriff, Fire, EMS", desc: "RiverCom dispatch · WSP" },
    { id: 45199, name: "Chelan County Public Safety (alt)", desc: "Secondary public-safety stream" },
  ],
  grant: [
    { id: 28878, name: "Grant Co. Fire/EMS & WSP", desc: "MACC911 fire dispatch + tactical · WSP" },
  ],
  kittitas: [
    { id: 2317, name: "Kittitas County Public Safety", desc: "Police · Sheriff · Fire · EMS" },
  ],
  klickitat: [
    { id: 40616, name: "Klickitat Co. Law, Fire, EMS", desc: "Primary law + fire dispatch" },
    { id: 42975, name: "Klickitat County Fire", desc: "Fire-only secondary" },
  ],
  yakima: [
    { id: 11194, name: "Yakima City & County Police, Fire, EMS", desc: "WSP included" },
  ],
  spokane: [
    { id: 17038, name: "Spokane City & County Fire / EMS", desc: "Primary fire dispatch" },
    { id: 17102, name: "Spokane Co. Sheriff & Fire — Digital", desc: "Digital trunked system" },
  ],
  stevens: [
    { id: 45481, name: "Stevens County Public Safety", desc: "Sheriff · Fire · EMS" },
  ],
  pend_oreille: [
    { id: 46181, name: "Pend Oreille County Public Safety", desc: "Sheriff · Fire · EMS" },
  ],
  ferry: [
    // No county-specific feed on Broadcastify; Ferry residents often listen to
    // Stevens or Inland Northwest regional feeds. Linking both as the best
    // available coverage until a dedicated feed appears.
    { id: 45481, name: "Stevens County Public Safety (regional)", desc: "Best regional coverage for Ferry Co." },
  ],
  whatcom: [
    { id: 38963, name: "Whatcom Co. Sheriff, Bellingham PD, WWU", desc: "Primary law-enforcement feed" },
    { id: 46809, name: "Whatcom County Fire Dispatch", desc: "Fire-only dispatch" },
    { id: 42249, name: "North Whatcom Fire Rescue", desc: "Northern WCFD" },
  ],
  skagit: [
    { id: 4958, name: "Skagit County Police and Fire", desc: "County-wide dispatch" },
  ],
};

export function feedsForCounty(slug) {
  return SCANNER_FEEDS[slug] || [];
}

// Direct MP3 stream URL (works without auth, no embed required)
export function feedStreamUrl(id) {
  return `https://broadcastify.cdnstream1.com/${id}`;
}

// Provider-hosted player (always works, opens in new tab as fallback)
export function feedEmbedUrl(id) {
  return `https://www.broadcastify.com/listen/feed/${id}/web`;
}

export function feedDetailUrl(id) {
  return `https://www.broadcastify.com/listen/feed/${id}`;
}
